import React, { createContext, useCallback, useMemo, useState } from 'react';

import { LoggerOverlayContextProps, LoggerOverlayData, LoggerOverlayState } from './loggerOverlay.types';

const initialLoggerOverlayState: LoggerOverlayState = {
	isOverlayVisible: false,
};

const initialLoggerOverlayContext: LoggerOverlayContextProps = {
	...initialLoggerOverlayState,
	showOverlay: () => null,
	hideOverlay: () => null,
};

export const LoggerOverlayContext = createContext<LoggerOverlayContextProps>({
	...initialLoggerOverlayContext,
});

export const PassLoggerOverlayProvider = {
	showOverlay: (data: LoggerOverlayData) => {
		return;
	},
	hideOverlay: () => {
		return;
	},
};

export const LoggerOverlayProvider = ({ children }: { children: React.ReactNode }) => {
	const [state, setState] = useState<LoggerOverlayState>(initialLoggerOverlayContext);

	const showOverlay = useCallback((data?: LoggerOverlayData) => {
		setState((prevState) => ({
			...prevState,
			isOverlayVisible: true,
			data,
		}));
	}, []);

	const hideOverlay = useCallback(() => {
		setState((prevState) => ({
			...prevState,
			isOverlayVisible: false,
		}));
	}, []);

	const value = useMemo(
		() => ({
			...state,
			showOverlay,
			hideOverlay,
		}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[state]
	);

	PassLoggerOverlayProvider.showOverlay = value.showOverlay;
	PassLoggerOverlayProvider.hideOverlay = value.hideOverlay;

	return <LoggerOverlayContext.Provider value={value}>{children}</LoggerOverlayContext.Provider>;
};
